module.exports = __webpack_public_path__ + "7e3d844d0445ad29035ddaa43c7b1a24.pdf";